import { render, staticRenderFns } from "./becomeTeacher.vue?vue&type=template&id=f85053da&scoped=true"
import script from "./becomeTeacher.vue?vue&type=script&lang=js"
export * from "./becomeTeacher.vue?vue&type=script&lang=js"
import style0 from "./becomeTeacher.vue?vue&type=style&index=0&id=f85053da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85053da",
  null
  
)

export default component.exports